import { render, staticRenderFns } from "./view-packet-complain-modal.vue?vue&type=template&id=7ab6c6a4&"
import script from "./view-packet-complain-modal.vue?vue&type=script&lang=js&"
export * from "./view-packet-complain-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports